import { reactive, Checkbox, P, Label, Button } from 'alkali'
import Dialog from '../generic/DialogAlkali'
import { patch } from 'tools/request'
import { app } from '../../app/app'
import './StudyList.scss'

export default class ThresholdCountDialog extends Dialog.with('.threshold-dialog') {

    get defaults() {
		return {
			head: {
				titleText: 'Studies Not Meeting Threshold',
			},
			id: 'threshold-dialog',
			size: '500px',
			foot: {},
		}
	}

    ready(properties) {
        const settings = app.user.Settings
        let showThresholdDialog = reactive(true)
        this.body.append(
            P(`${properties.missedThresholdCount} studies were not auto-selected because they did meet the matching threshold of ${properties.autoSelectThreshold}%. To change the threshold, click on the menu icon next to the select all checkbox`)
        )
        this.footer.rightControls.append(Button('.btn', {
            textContent: 'Continue',
            onclick: () => {
                if (properties?.showDialog) {
                    showThresholdDialog.put(false)
                    settings.Tour.showThresholdDialog = showThresholdDialog.valueOf()
                    patch<User>('/portal/User/' + app.user.Id, {
                        data: { settings }
                    })
                }
                return this.hide()
            }
        }))
        this.footer.leftControls.append(Label('.checkbox', [
            Checkbox({
                onchange() {
                    return this.checked ? properties.showDialog = true : properties.showDialog = false
                }
            }), " Don't show this message again"
        ]))
    }

    show() {
        super.show()
    }
}